import React from 'react'
import parse from 'html-react-parser'
// @ts-ignore
import { ShoppingCart, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import i18n from 'i18n'

import MetadataIconsContainer from './MetadataIconsContainer'

const getTooltip = (productName?: string, productHierarchy?: string) => {
  const productNameTooltip = productName ? `${i18n.t('productName_other')}: ${productName}` : ''
  const productHierarchyTooltip = productHierarchy
    ? `${i18n.t('productHierarchy_other')}:<br>${productHierarchy}`
    : ''

  if (productNameTooltip && productHierarchyTooltip) {
    return parse(`${productNameTooltip}<br>${productHierarchyTooltip}`)
  }

  if (productNameTooltip) {
    return parse(productNameTooltip)
  }

  if (productHierarchyTooltip) {
    return parse(productHierarchyTooltip)
  }

  return ''
}

type ShoppingCartIconProps = {
  productNameText: string
  productName?: string
  productHierarchy?: string
}

const ShoppingCartIcon = ({
  productNameText,
  productName,
  productHierarchy
}: ShoppingCartIconProps) => {
  const theme = useDisplayTheme() as Theme
  const color = sys[theme].text.placeholder
  const tooltip = getTooltip(productName, productHierarchy)

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <div>
        <MetadataIconsContainer message={productNameText}>
          <ShoppingCart color={color} />
        </MetadataIconsContainer>
      </div>
    </Tooltip>
  )
}

export default ShoppingCartIcon
